import { types } from "../../types/types";

const initialState = {
  buscadorPracticas: [],
  practicas: [],
  valorizaciones: [],
};

export const cosegurosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.coseguroResetBuscadorPracticas:
      return {
        ...state,
        buscadorPracticas: [],
      };
    case types.coseguroGetBuscadorPracticasSuccess:
      return {
        ...state,
        buscadorPracticas: action.payload,
      };
    case types.coseguroGetBuscadorPracticasError:
      return {
        ...state,
        buscadorPracticas: action.payload,
      };
    case types.coseguroGetPracticasSuccess:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.coseguroGetPracticasError:
      return {
        ...state,
        practicas: [],
      };
    case types.coseguroVaciarPracticas:
      return {
        ...state,
        practicas: [],
      };
    case types.coseguroAddPractica:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.coseguroGetValorizacionesSuccess:
      return {
        ...state,
        valorizaciones: action.payload,
      };
    case types.coseguroGetValorizacionesError:
      return {
        ...state,
        valorizaciones: [],
      };
    case types.coseguroResetValorizaciones:
      return {
        ...state,
        valorizaciones: [],
      };
    default:
      return state;
  }
};
